import styles from "./SidebarMenu.module.css";
import { Colorlogo, Logout_Icon } from "../../../src/controller/Images";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import { deepOrange } from "@mui/material/colors";
import Cookies from "js-cookie";

const SidebarMenu = ({ isOpen, setIsOpen }) => {
  const location = useLocation();
  const JOB = location?.state?.job_id;
  const FILTERS = location?.state?.filters;
  const { blogData, editBlog } = location.state || {};

  const [title, setTitle] = useState({
    title: "",
    back: "",
  });

  const fullName = decodeURIComponent(Cookies.get("full_name") || "User");
  const designation = decodeURIComponent(Cookies.get("user_designation") || "");
  const firstLetter = fullName.charAt(0).toUpperCase();

  const [breadcrumb, setBreadcrumb] = useState({
    title: "",
    backText: "",
    navigate: "",
  });

  const navigate = useNavigate();
  // const handlenavigate = () => {
  //   if (title.navigate) {
  //     navigate(title.navigate);
  //   } else {
  //     console.warn("Navigate path not defined");
  //   }
  // };
  const handlenavigate = () => {
    // 1. Specific back navigations that require passing state (filters)
    if (location.pathname === "/admin/job-view" && location.state?.jobFilters) {
      navigate("/admin/join-our-team", {
        state: { jobFilters: location.state.jobFilters },
      });
      return;
    }

    if (
      location.pathname === "/admin/lets-talk/view" &&
      location.state?.appliedFilters
    ) {
      navigate("/admin/lets-talk", {
        state: { appliedFilters: location.state.appliedFilters },
      });
      return;
    }

    if (
      location.pathname.startsWith("/admin/Blog-View") &&
      location.state?.blogfilters
    ) {
      navigate("/admin/Blog", {
        state: { blogfilters: location.state.blogfilters },
      });
      return;
    }

    if (
      location.pathname === "/admin/candidates-view" &&
      location.state?.candidateFilters
    ) {
      navigate("/admin/candidates-list", {
        state: { candidateFilters: location.state.candidateFilters },
      });
      return;
    }

    // 2. Dynamic 'Back to Job Page' logic using 'from' state
    // This is handled via the 'title.navigate' set in useEffect
    if (location.state?.from === "jobpage" && title.navigate) {
      navigate(title.navigate, {
        state: { from: "candidates-view", jobId: JOB, filters: FILTERS },
      }); // Keep context if needed
      return;
    }

    // 3. Fallback: Use the path defined in useEffect (e.g., Back to Dashboard, Back to List)
    if (title.navigate) {
      navigate(title.navigate);
      return;
    }

    // 4. Ultimate fallback (Optional, if title.navigate isn't set for some reason)
    // You could also use: navigate(-1);
    console.warn("Navigate path not defined or ultimate fallback reached.");
  };

  const handleLogout = () => {
    // Remove all login-related cookies
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
    Cookies.remove("user_id"); // internal DB id
    Cookies.remove("full_name");
    Cookies.remove("user_type");
    Cookies.remove("user_designation");
    Cookies.remove("user_uuid"); // UUID or unique id
    Cookies.remove("user_name");
    Cookies.remove("email");
    Cookies.remove("user_info");

    // Redirect to login page
    navigate("/admin/AdminLogin");
  };

  useEffect(() => {
    const pathMetaMap = {
      "/admin": { mainTitle: "Dashboard", backText: "", navigate: "" },
      "/admin/lets-talk": {
        mainTitle: "Let's Talk",
        // backText: "Back to Dashboard",
        navigate: "#",
      },
      "/admin/lets-talk/view": {
        mainTitle: "View Let’s Talk Details",
        backText: "Back to Let's Talk",
        navigate: "/admin/lets-talk",
      },
      "/admin/join-our-team": {
        mainTitle: "Join Our Team",
        // backText: "Back to Dashboard",
        navigate: "#",
      },
      "/admin/job-create": ({ editJob }) => ({
        mainTitle: editJob ? "Edit Job" : "Create Job",
        backText: "Back to Join Our Team",
        navigate: "/admin/join-our-team",
      }),
      "/admin/job-view": {
        mainTitle: "View Job Details",
        backText: "Back to Join Our Team",
        navigate: "/admin/join-our-team",
      },
      "/admin/candidates-list": {
        mainTitle: "Candidates",
        // backText: "Back to Dashboard",
        navigate: "#",
      },
      "/admin/candidates-view": {
        mainTitle: "Candidate Job Details",
        backText: "Back to Candidates List",
        navigate: "/admin/candidates-list",
      },
      "/admin/AdminLogin": {
        mainTitle: "Admin Login",
        backText: "Back to Home",
        navigate: "/",
      },
      // 👇 Dynamic Create/Edit Blog
      "/admin/create-blog": ({ editBlog }) => ({
        mainTitle: editBlog ? "Edit Blog" : "Create Blog",
        backText: "Back to Blogs",
        navigate: "/admin/Blog",
      }),
      "/admin/Blog": {
        mainTitle: "Blogs",
        // backText: "Back to Dashboard",
        navigate: "#",
      },
      default: {
        mainTitle: "Blog Details",
        backText: "Back to Blog List",
        navigate: "/admin/Blog",
      },
    };

    let currentPath = location.pathname;
    // let meta = pathMetaMap[currentPath] || pathMetaMap["default"];
    let meta =
      typeof pathMetaMap[currentPath] === "function"
        ? pathMetaMap[currentPath](location.state || {})
        : pathMetaMap[currentPath] || pathMetaMap["default"];

    // Handle dynamic back based on state.from
    if (location.state?.from) {
      if (
        currentPath === "/admin/candidates-view" &&
        location.state.from === "jobpage"
      ) {
        meta.backText = "Back to Job Page";
        meta.navigate = {
          pathname: "/admin/job-view",
          state: { jobId: JOB },
        };
      }
    }

    setTitle({
      title: meta.mainTitle,
      back: meta.backText,
      navigate: meta.navigate,
    });

    setBreadcrumb({
      title: meta.mainTitle,
      backText: meta.backText?.replace(/back to\s*/i, ""),
      navigate: meta.navigate,
    });
  }, [location.pathname, location.state]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="d-flex">
      {/* Sidebar */}
      <div className={`${styles.nav_bar} ${isOpen ? styles.visible : ""}`}>
        <div className="">
          {/* Logo */}
          <div className={`${styles.Custom_image}`}>
            <img src={Colorlogo} alt="Logo" className={`${styles.image}`} />
          </div>
          <div className={`p-3 ${styles.profileCard}`}>
            <Avatar sx={{ bgcolor: deepOrange[500], width: 40, height: 40 }}>
              {firstLetter}
            </Avatar>
            <div className={`ms-3 ${styles.info}`}>
              <div className={styles.name}>{fullName}</div>
              <div className={`ps-2 ${styles.role}`}>{designation}</div>
            </div>
          </div>

          <nav className={`py-3 ${styles.nav_links}`}>
            <ul>
              {/* Lets Talk */}
              <li
                className={
                  location.pathname.startsWith("/admin/lets-talk")
                    ? styles.active
                    : ""
                }
              >
                <Link to="/admin/lets-talk">Lets Talk</Link>
              </li>

              {/* Join Our Team */}
              <li
                className={
                  location.pathname.startsWith("/admin/join-our-team") ||
                  location.pathname.startsWith("/admin/job-create") ||
                  location.pathname.startsWith("/admin/job-view")
                    ? styles.active
                    : ""
                }
              >
                <Link to="/admin/join-our-team">Join Our Team</Link>
              </li>

              {/* Candidates */}
              <li
                className={
                  location.pathname.startsWith("/admin/candidates-list") ||
                  location.pathname.startsWith("/admin/candidates-view")
                    ? styles.active
                    : ""
                }
              >
                <Link to="/admin/candidates-list">Candidate</Link>
              </li>

              {/* Blog */}
              <li
                className={
                  location.pathname.startsWith("/admin/Blog") ||
                  location.pathname.startsWith("/admin/create-blog")
                    ? styles.active
                    : ""
                }
              >
                <Link to="/admin/Blog">Blog</Link>
              </li>
            </ul>
          </nav>
        </div>

        {/* Logout button */}
        <div className={styles.logout}>
          <button className={styles.logout_button} onClick={handleLogout}>
            <img
              src={Logout_Icon}
              alt="Logout Icon"
              className={styles.logout_icon}
            />
            Logout
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div
        className={`${styles.main_content} ${
          isOpen ? styles.content_shifted : ""
        }`}
      >
        <div className={`container-fluid ${styles.header}`}>
          <div className="row align-items-center justify-content-between">
            <div className="col-6 d-flex align-items-center">
              <div
                className={`${styles.toggle_btn} ${
                  isOpen ? styles.onclick : ""
                }`}
                onClick={handleToggle}
              >
                <span></span>
              </div>
              <div className={`ps-3 ${styles.title}`}> {title.title}</div>
            </div>
            <div className="col-6 text-end">
              <div
                className={styles.dashboardLink}
                onClick={handlenavigate}
                style={{ cursor: "pointer" }}
              >
                {title?.back?.trim() && (
                  <ChevronLeftIcon className={styles.icon} />
                )}
                {title?.back}
              </div>
              {/* <div className={styles.dashboardLink}>Back to Dashboard</div> */}
            </div>
          </div>
        </div>
        <nav aria-label="breadcrumb" className="px-3 pt-2">
          <ol className="breadcrumb">
            {breadcrumb.backText && breadcrumb.navigate ? (
              // <li className="breadcrumb-item">
              //   <a href={breadcrumb.navigate}>{breadcrumb.backText}</a>
              // </li>
              <li className="breadcrumb-item">
                <a
                  href="#!"
                  onClick={(e) => {
                    e.preventDefault();
                    handlenavigate();
                  }}
                >
                  {breadcrumb.backText}
                </a>
              </li>
            ) : null}
            <li className="breadcrumb-item active" aria-current="page">
              {breadcrumb.title}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default SidebarMenu;
